import { Link } from "react-router-dom";
import { useLocale } from "../i18n/LocaleContext";
import { Reveal } from "../components/Reveal";

export default function NotFound() {
  const { t, link } = useLocale();
  return (
    <div data-testid="not-found-page" className="flex min-h-[80vh] items-center">
      <section className="mx-auto max-w-3xl px-6 py-40 text-center">
        <Reveal>
          <p className="font-serif italic text-8xl text-imperium-champagne sm:text-9xl" data-testid="not-found-code">{t("notfound.title")}</p>
          <h1 className="mt-8 font-serif text-3xl font-light text-imperium-black sm:text-4xl">{t("notfound.heading")}</h1>
          <p className="mt-6 text-base font-light text-imperium-black/60">{t("notfound.text")}</p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-8">
            <Link to={link("home")} data-testid="not-found-home-link" className="border border-imperium-bronze px-8 py-4 text-[11px] font-label uppercase tracking-[0.25em] text-imperium-brown transition-colors duration-300 hover:bg-imperium-brown hover:text-imperium-white">
              {t("cta.backHome")}
            </Link>
            <Link to={link("treatments")} data-testid="not-found-treatments-link" className="link-line text-[11px] font-label uppercase tracking-[0.25em] text-imperium-brown">
              {t("nav.treatments")}
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
